import { createSelector } from 'reselect';
import { getConfigData } from 'src/modules/config/selectors/getConfigData';

export const getConfigHvac = createSelector([
  getConfigData,
], (config) => config.hvac);
